import i18n from '@/lang/index'
export const columnData = [
   {
        key: 'sn',
        text: i18n.t('invoicesCenter.columnSn'),
        width: '200px',
        fixed: 'left'
    }, {
        key: 'stateDesc',
        text: i18n.t('invoicesCenter.columnStatedesc'),
        width: '200px',
        fixed: 'left',
        remind: {
            text: `
                ${i18n.t('invoicesCenter.stateDraft')}<br/>
                ${i18n.t('invoicesCenter.statePresubmit')}<br/>
                ${i18n.t('invoicesCenter.stateIssued')}<br/>
                ${i18n.t('invoicesCenter.statePicking')}<br/>
                ${i18n.t('invoicesCenter.statePickcompleted')}<br/>
                ${i18n.t('invoicesCenter.stateShipped')}<br/>
                ${i18n.t('invoicesCenter.stateSignedV1')}<br/>
                ${i18n.t('invoicesCenter.stateCheckingV3')}<br/>
                ${i18n.t('invoicesCenter.stateStored')}<br/>
                ${i18n.t('invoicesCenter.stateVoided')}<br/>
                ${i18n.t('invoicesCenter.stateVoidapplying')}<br/>
          `,
            style: {
                width: '400px',
                'font-size': '12px',
                'text-align': 'left'
            }
        },
        template: () => {
            return `
              <div style="display:flex;align-items:center;">
                  <span v-if="row.state == 0" style="width:10px;height:10px;border-radius:35%;margin-right:10px;background:#F8475F;"></span>
                  <span v-else-if="[4,6,8,12,14].includes(+row.state)" style="width:10px;height:10px;border-radius:35%;margin-right:10px;background:#43D268;"></span>
                  <span v-else-if="[5,7,11].includes(+row.state)" style="width:10px;height:10px;border-radius:35%;margin-right:10px;background:#FF9000;"></span>
                  <span v-else-if="[1,9,10].includes(+row.state)" style="width:10px;height:10px;border-radius:35%;margin-right:10px;background:#067CF2;"></span>
                  <span v-else-if="row.state == 2" style="width:10px;height:10px;border-radius:35%;margin-right:10px;background:#BD73D3;"></span>
                  <span v-else-if="row.state == 19" style="width:10px;height:10px;border-radius:35%;margin-right:10px;background:#F8475F;"></span>
                  <span v-else style="width:10px;height:10px;border-radius:35%;margin-right:10px;background:#999;"></span>
                  <span>{{row.stateDesc}}</span>
              </div>
          `
        }
    },
    {
        key: 'ifDiscrepancy',
        text: i18n.t('invoicesCenter.columnIfdiscrepancy'),
        width: '200px',
        template: () => {
            return `
                <div>{{row.ifDiscrepancy === 'Y' ? '${i18n.t('invoicesCenter.columnYes')}' : '${i18n.t('invoicesCenter.columnNo')}'}}</div>
            `
        }
    },
    {
        key: 'marketName',
        text: i18n.t('invoicesCenter.columnMarketname'),
        width: '250px'
    },
    { key: 'warehouseName', text: i18n.t('invoicesCenter.columnWarehousename'), width: '250px' },

    { key: 'totalNum', text: i18n.t('invoicesCenter.columnTotalnum'), width: '150px',
     template: (e, row) => {
        return `<span>{{row.totalNum==='0'?'':row.totalNum}}<span>`
    } },
    { key: 'outNum', text: i18n.t('invoicesCenter.columnOutnum'), width: '150px',
     template: (e, row) => {
        return `<span>{{row.outNum==='0'?'':row.outNum}}<span>`
    } },
    { key: 'outPackageNum', text: i18n.t('invoicesCenter.columnOutpackagenum'), width: '180px',
        template: (e, row) => {
            return `<span>{{row.outPackageNum==='0'?'':row.outPackageNum}}<span>`
        }
    },
    {
        key: 'outNumDifference',
        text: i18n.t('invoicesCenter.columnOutnumdifference'),
        width: '180px',
        template: (e, row) => {
            return `<span style="color:red">{{row.outNumDifference==='0'?'':row.outNumDifference}}<span>`
        }
    },
    { key: 'inNum', text: i18n.t('invoicesCenter.columnInnum'), width: '150px',
      template: (e, row) => {
        return `<span>{{row.inNum==='0'?'':row.inNum}}<span>`
    } },
    {
        key: 'inNumDifference',
        text: i18n.t('invoicesCenter.columnInnumdifference'),
        width: '180px',
        template: (e, row) => {
            return `<span  style="color:red">{{row.inNumDifference==='0'?'':row.inNumDifference}}<span>`
        }
    },
    { key: 'logisticPackageCheckNum', text: i18n.t('invoicesCenter.columnLogisticpackagechecknum'), width: '180px',
        template: (e, row) => {
            return `<span>{{row.logisticPackageCheckNum==='0'?'':row.logisticPackageCheckNum}}<span>`
        }
    },
    { key: 'remark', text: i18n.t('invoicesCenter.columnRemark'), width: '150px' },
    { key: 'createUserName', text: i18n.t('invoicesCenter.columnCreateusername'), width: '180px' },
    {
        key: 'createTime',
        text: i18n.t('invoicesCenter.columnCreatetime'),
        width: '160px',
    },
    { key: 'updateTime', text: i18n.t('invoicesCenter.columnUpdatetime'), width: '160px' },
    { key: 'updateUserName', text: i18n.t('invoicesCenter.columnUpdateusername'), width: '180px' }
    // {
    //   key: "operate",
    //   text: "操作",
    //   width: "200px",
    //   fixed: "right",
    //   template: () => {
    //     return `
    //       <el-button type="text" style="padding: 0;font-size: 14px; color: #0B83F3;" v-if="row.state != 101" @click="changeType(row)" class="operate-btn">详情</el-button>
    //       <el-button type="text" style="padding: 0;font-size: 14px; color: #0B83F3;" v-if="row.state == 101" @click="editDetail(row)" class="operate-btn">编辑</el-button>
    //       <el-button type="text" style="padding: 0;font-size: 14px; color: #ff9c1c;" v-if="row.state == 105" @click="handleCommand('checkGet', row)" class="operate-btn">发货</el-button>
    //       <el-button type="text" style="padding: 0;font-size: 14px; color: #bf79d4;" v-if=" [103, 104].includes(+row.state)" @click="handleCommand('startGet', row)" class="operate-btn">拣货</el-button>
    //       <el-button type="text" style="padding: 0;font-size: 14px; color: #47d26b;" v-if="row.state != 101" @click="handleCommand('print', row)" class="operate-btn">打印</el-button>
    //       <el-button type="text" style="padding: 0;font-size: 14px; color: #f84f66;"v-if="row.typeCode==100020&& [101,102,103].includes(+row.state)" @click="handleCommand('void', row)" class="operate-btn">作废</el-button>
    //   `;
    //   },
    // },
]
export const options = {
    searchItem: [
        {
            id: '2',
            type: 'input',
            size: 'small',
            clearable: true,
            placeholder: i18n.t('invoicesCenter.placeholderSn'),
            label: i18n.t('invoicesCenter.labelSn'),
            value: '',
            resField: 'snList'
        },
        {
            id: '3',
            type: 'input',
            size: 'small',
            clearable: true,
            placeholder: i18n.t('invoicesCenter.placeholderExpressnoV1'),
            label: i18n.t('invoicesCenter.labelExpressnoV1'),
            value: '',
            resField: 'expressNo'
        },
        {
            id: '1',
            type: 'select',
            size: 'small',
            clearable: true,
            placeholder: i18n.t('invoicesCenter.placeholderStateV1'),
            label: i18n.t('invoicesCenter.labelStateV1'),
            value: '',
            resField: 'stateList',
            multiple: true,
            list: [
                { name: i18n.t('invoicesCenter.optionsDraft'), value: '1' },
                { name: i18n.t('invoicesCenter.optionsIssued'), value: '4' },
                { name: i18n.t('invoicesCenter.optionsPicking'), value: '5' },
                { name: i18n.t('invoicesCenter.optionsPickcompleted'), value: '6' },
                { name: i18n.t('invoicesCenter.optionsPackcompleted'), value: '8' },
                { name: i18n.t('invoicesCenter.optionsShipped'), value: '9' },
                { name: i18n.t('invoicesCenter.optionsSigned'), value: '10' },
                { name: i18n.t('invoicesCenter.optionsChecking'), value: '11' },
                { name: i18n.t('invoicesCenter.optionsStored'), value: '14' },
                { name: i18n.t('invoicesCenter.optionsVoidapplying'), value: '19' },
                { name: i18n.t('invoicesCenter.optionsVoided'), value: '0' }
            ]
        },
        {
            id: 'ifDiscrepancy',
            type: 'select',
            size: 'small',
            clearable: true,
            placeholder: i18n.t('invoicesCenter.placeholderSelectV1'),
            label: i18n.t('invoicesCenter.labelIfdiscrepancyV1'),
            value: '',
            resField: 'ifDiscrepancy',
            multiple: false,
            list: [
                { value: 'Y', name: i18n.t('invoicesCenter.columnYes') },
                { value: 'N', name: i18n.t('invoicesCenter.columnNo') }
            ]
        },
        {
            id: 'hasDiscrepancy',
            type: 'select',
            size: 'small',
            clearable: true,
            placeholder: i18n.t('invoicesCenter.placeholderSelectV1'),
            label: i18n.t('invoicesCenter.labelHasdiscrepancyV1'),
            value: '',
            resField: 'hasDiscrepancy',
            multiple: false,
            list: [
                { value: 'Y', name: i18n.t('invoicesCenter.columnYes') },
                { value: 'N', name: i18n.t('invoicesCenter.columnNo') }
            ]
        },
        // {
        //     id: 'warehouseIdList',
        //     type: 'selectEntre',
        //     size: 'small',
        //     clearable: true,
        //     placeholder: '请选择',
        //     label: '收货方',
        //     value: [],
        //     resField: 'warehouseIdList',
        //     list: [],
        //     multiple: true,
        //     filterable: true,
        //     remote: true
        // },
        {
            id: 'warehouseIdList',
            type: 'warehouse',
            placeholder: i18n.t('invoicesCenter.placeholderWarehouse'),
            label: i18n.t('invoicesCenter.columnWarehousename'),
            value: [],
            resField: 'warehouseIdList'
        },
        {
            // id: 'spuList',
            // type: 'goodsNoSelector',
            // placeholder: '请选择货号',
            // label: '货号',
            // modelKey: 'spu',
            // multiple: true, //单选
            // value: '', //单选
            // value: [],//多选
            // resField: 'spuList'
            id: 'goodsNo',
            type: 'goodsNoSelector',
            placeholder: i18n.t('invoicesCenter.placeholderGoodsnoV1'),
            label: i18n.t('invoicesCenter.labelGoodsnoV1'),
            modelKey: 'goodsNo',
            multiple: true,
            value: '',
            inputShow: true,
            slectShow: false,
            resField: 'spuList'
        },
        // {
        //     id: '7',
        //     type: 'selectUser',
        //     size: 'small',
        //     clearable: true,
        //     placeholder: '请选择创建人',
        //     label: '创建人',
        //     value: '',
        //     resField: 'createUser',
        //     list: [],
        //     filterable: true,
        //     remote: true
        // },
        {
            id: "UserInput",
            type: "input",
            size: "small",
            clearable: true,
            placeholder: i18n.t('invoicesCenter.placeholderCreateuserV1'),
            label: i18n.t('invoicesCenter.labelCreateuserV1'),
            value: "",
            resField: "createUserName",
        },
        {
            id: '8',
            type: 'daterange',
            size: 'small',
            clearable: true,
            placeholder: i18n.t('invoicesCenter.placeholderCreatetimeV1'),
            label: i18n.t('invoicesCenter.labelCreatetimeV1'),
            value: '',
            resField: 'createTime',
            valueFormat: 'yyyy-MM-dd'
        },
        {
            id: '9',
            type: 'daterange',
            size: 'small',
            clearable: true,
            placeholder: i18n.t('invoicesCenter.placeholderUpdatetimeV1'),
            label: i18n.t('invoicesCenter.labelUpdatetimeV1'),
            value: '',
            resField: 'updateTime',
            valueFormat: 'yyyy-MM-dd'
        }
    ],
    // 确认按钮
    sureBtnVisable: true,
    sureBtnType: 'primary',
    sureBtnSize: 'medium',
    sureBtnText: i18n.t('invoicesCenter.buttonQuery'),
    //重置按钮
    restBtnVisable: true,
    restBtnType: '',
    restBtnSize: 'medium',
    restBtnText: i18n.t('invoicesCenter.buttonReset')
}
